<template>
  <div class="gray-back">
    <div class="box member-service-box">
      <van-cell-group v-for="(member, index) in list" :key="index">
        <van-cell title="姓名" :value="member.name"></van-cell>
        <van-cell title="性别" :value="member.sex"></van-cell>
        <van-cell title="身份证号" :value="member.num"></van-cell>
        <van-cell title="联系电话" :value="member.phone"></van-cell>
        <van-cell title="微信" :value="member.weixin"></van-cell>
        <van-cell title="申报项目" :value="member.project" v-if="row.memberstatus == 6"></van-cell>
        <van-cell title="抱腿平衡" :value="member.score_btph" v-if="row.memberstatus == 6 && (member.project== '花球男' || member.project== '花球女')"></van-cell>
        <van-cell title="肋木举腿" :value="member.score_lmjt" v-else-if="row.memberstatus == 6"></van-cell>
        <van-cell title="60s(击掌)俯卧撑" :value="member.score_fwc" v-if="row.memberstatus == 6"></van-cell>
        <van-cell title="技术技巧" :value="member.score_jsjq" v-if="row.memberstatus == 6"></van-cell>
        <van-cell title="总分" :value="member.score_total" v-if="row.memberstatus == 6"></van-cell>
        <van-cell title="选择项目" :value="member.project" v-else is-link @click="onProjectOpen(index)"></van-cell>
      </van-cell-group>

      <van-popup v-model="projectShow" position="bottom">
        <van-picker :columns="projectColumns"
                    show-toolbar
                    @cancel="projectShow = false"
                    @confirm="onProjectConfirm"
        />
      </van-popup>
      <div style="height: 50px"></div>
      <div class="savebtn" v-if="row.memberstatus != 6">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
            @click="onSubmit">确认报名
        </van-button>
      </div>

    </div>
  </div>
</template>
<style scoped>
.member-service-box .van-cell__value {
  color: #333;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}
</style>

<script>
import Vue from 'vue';
import validator from "../../../utils/validator";
import IdCardPicker from "../../../components/picker/IdCardPicker.vue";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  CellGroup,
  Toast,
  Dialog,
  Icon,
  PullRefresh,
  List,
  Tag,
  Button,
  DropdownMenu,
  DropdownItem,
  DatetimePicker
} from 'vant';
import area from "../../../utils/area";

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(DropdownItem).use(DatetimePicker);
export default {
  name: 'AbilityApplyMemberService',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    IdCardPicker,
    PicUploader,
    FileUploader
  },
  data: function () {
    return {
      validator,
      id: 0,
      active: 0,
      projectShow: false,
      showArea: false,
      showGradePicker: false,
      showProjectPicker: false,
      showOldGradePicker: false,
      showOldProjectPicker: false,
      actionShow: false,
      addShow: false,
      list: [],
      row: {},
      areaList: {},
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker: false,
      projectColumns: ['花球男', '花球女', '技巧男', '技巧女', '街舞男', '街舞女'],
      actions: [
        {name: '隐藏'},
        {name: '认证'},
      ],
      params: {
        pageNo: 1,
        pageSize: 10,
        keywords: '',
        cate_id: 0,
        is_show: 1
      },
      formData: {
        name: '',
        num: '',
        minzu: '',
        huzhao: '',
        cardtype: 1,
        birthday: '',
        sex: 1,
        zhengjianimg: [],
        pic: [],
        attsrc: [],
      },
      memberIndex: 0,
      saveLoading: false,
      isLoading: false,
      loading: false,
      finished: false,

    }
  },
  mounted() {
    document.title = "能力测试项目选择"
    this.areaList = area;
    this.params.id = this.$route.query.id
    this.getList();
  },
  computed: {},
  filters: {
  },
  destroyed() {
  },
  methods: {
    getList() {
      let that = this;
      that.$api.get('/api/ability/abilityApplyMemberList', that.params, (res) => {
        that.list = res.data.list;
        that.row = res.data.row;
      })
    },

    onProjectOpen(index) {
      this.projectShow = true
      this.memberIndex=index
    },

    onProjectConfirm(value) {
      console.log(value)
      this.list[this.memberIndex].project = value
      this.projectShow = false;
    },

    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      let count = 0
      that.list.map(field => {
        if (!field.project) {
          Toast(field.name + '请选择项目');
          count++
        }
      })
      if(count) {
        return
      }
      that.saveLoading = true;
      that.$api.post('/api/ability/memberServiceApply',{
        id: that.params.id,
        list: JSON.stringify(that.list)
      }, (res) => {
        that.saveLoading = false;
        that.getList()
        Toast.success('报名成功')
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    onTongbu() {
      let that = this;
      that.$api.post('/api/yundongyuan/tongbuCca', {}, (res) => {
        Toast(res.msg);
        that.onRefresh();
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },

    // 更改状态
    onStatusChange(index) {

      let that = this;
      that.params.is_show = index + 1;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      this.$route.query.is_show = 0;
      that.getList()
    },


  }
}
</script>



// WEBPACK FOOTER //
// AbilityApplyMemberService.vue?3eeb5db8